export default {
  menuDrawerStatus: false,
  alertas: [],
  notificacionesIndividuales: [],
  stompClient: null
}
